import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { UserPlus, Users, Sparkles, ChevronRight } from 'lucide-react';
import { API, useAuth } from '../context/AuthContext';
import { useLang } from '../context/LangContext';

const SuggestedCreators = () => {
  const { user } = useAuth();
  const { lang } = useLang();
  const [creators, setCreators] = useState([]);
  const [followed, setFollowed] = useState(new Set());

  useEffect(() => {
    if (!user) return;
    axios.get(`${API}/creators/suggested`, { withCredentials: true })
      .then(r => setCreators(r.data.creators || []))
      .catch(() => {});
  }, [user]);

  const toggleFollow = async (uid, e) => {
    e.preventDefault(); e.stopPropagation();
    try {
      if (followed.has(uid)) {
        await axios.delete(`${API}/follow/${uid}`, { withCredentials: true });
        setFollowed(prev => { const n = new Set(prev); n.delete(uid); return n; });
      } else {
        await axios.post(`${API}/follow/${uid}`, {}, { withCredentials: true });
        setFollowed(prev => new Set(prev).add(uid));
      }
    } catch (_) {}
  };

  if (!user || creators.length === 0) return null;

  return (
    <section className="py-12 md:py-16 bg-gradient-to-b from-white via-cyan-50/30 to-white">
      <div className="max-w-[1400px] mx-auto px-5 md:px-10">
        <div className="flex items-end justify-between mb-6">
          <div>
            <div className="inline-flex items-center gap-2 bg-neutral-900 rounded-full px-3 py-1 mb-3">
              <Sparkles className="w-3.5 h-3.5 text-cyan-400" />
              <span className="text-[11px] font-bold uppercase tracking-wider text-white">{lang === 'sv' ? 'För dig' : 'مقترح لك'}</span>
            </div>
            <h2 className="text-3xl md:text-4xl font-black tracking-[-0.02em] text-neutral-900">{lang === 'sv' ? 'Skapare att följa' : 'مبدعون للمتابعة'}</h2>
            <p className="mt-2 text-[14px] text-neutral-600">{lang === 'sv' ? 'Baserat på taggar och videor du gillar' : 'بناءً على الوسوم والفيديوهات التي تحبها'}</p>
          </div>
        </div>
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
          {creators.map(c => {
            const isFollowed = followed.has(c.user_id);
            return (
              <a key={c.user_id} href={`/u/${c.user_id}`} className="group relative bg-white rounded-2xl border border-neutral-200 p-5 text-center hover:shadow-xl hover:-translate-y-1 transition-all">
                {c.picture ? <img src={c.picture} alt={c.name} className="w-20 h-20 rounded-2xl object-cover mx-auto mb-3" referrerPolicy="no-referrer" /> : <div className="w-20 h-20 rounded-2xl bg-gradient-to-br from-cyan-400 to-fuchsia-500 flex items-center justify-center text-white text-2xl font-black mx-auto mb-3">{c.name?.[0] || 'U'}</div>}
                <div className="font-bold text-[14px] text-neutral-900 truncate">{c.name}</div>
                <div className="text-[11.5px] text-neutral-500 mt-1 flex items-center gap-2 justify-center">
                  <span className="inline-flex items-center gap-1"><Users className="w-3 h-3" /> {c.followers}</span>
                  <span>·</span>
                  <span>{c.video_count} {lang === 'sv' ? 'vid.' : 'فيديو'}</span>
                </div>
                <button onClick={(e) => toggleFollow(c.user_id, e)} className={`mt-3 w-full h-9 rounded-full font-bold text-[12px] transition-colors ${isFollowed ? 'bg-neutral-100 text-neutral-800 hover:bg-neutral-200' : 'bg-black hover:bg-neutral-800 text-white'}`}>
                  {isFollowed ? (lang === 'sv' ? 'Följer' : 'يتابع') : (<><UserPlus className="w-3 h-3 inline mr-1 rtl:mr-0 rtl:ml-1" />{lang === 'sv' ? 'Följ' : 'تابع'}</>)}
                </button>
              </a>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default SuggestedCreators;
